import { useState } from 'react';
import TrialModal from '../../../components/feature/TrialModal';

export default function ElementarySection() {
  const [activeTab, setActiveTab] = useState('大班升小一');
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isTrialModalOpen, setIsTrialModalOpen] = useState(false);

  const courses = {
    '大班升小一': {
      title: '大班升小一銜接班',
      image: 'https://public.readdy.ai/ai/img_res/d1c0beecfa9e581e41290d08985783a7.jpg',
      features: ['注音符號', '基礎數學', '握筆練習', '專注力訓練'],
      description: '專為大班孩子設計的小一預備課程，幫助孩子順利銜接小學生活，建立良好的學習基礎。',
      schedule: '週一至週五 15:30-17:30',
      highlights: ['小班制教學', '個別指導', '學習習慣養成', '親師溝通']
    },
    '小一安親班': {
      title: '1年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/12fba59492bc05c8974be5feab0e1d51.jpeg',
      features: ['安親+數學+英文+國語', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語=平均6375元。提供完善的課後照顧服務，協助小一新生適應學校生活。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '小班制教學', '多元課程'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '低年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '小二安親班': {
      title: '2年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/bcb595bf0815ea355f0e09f742e4a07d.jpeg',
      features: ['安親+數學+英文+國語', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語=平均6375元。針對小二學童的學習特性，提供個別化的課業輔導，培養獨立學習的能力。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '個別輔導', '學習規劃'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '低年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '小三安親班': {
      title: '3年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/832c9d8ed9a006a9a7858a761daebad9.jpeg',
      features: ['安親+數學+英文+國語+自然', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語+自然=平均6875元。小三是學習的重要轉折點，新增自然科目，提供全方位的學習支援。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '基礎鞏固', '閱讀培養'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '中年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '小四安親班': {
      title: '4年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/483c46b2220f9df58a2651445784eeb9.jpeg',
      features: ['安親+數學+英文+國語+自然', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語+自然=平均6875元。小四學童開始接觸更複雜的學習內容，我們提供進階的學習輔導和能力培養。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '深度學習', '專題探索'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '中年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '小五安親班': {
      title: '5年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/88838a058e54ec913a8f82b59b4efd38.jpeg',
      features: ['安親+數學+英文+國語+自然+社會', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語+自然+社會=平均7375元。小五是高年級的開始，我們著重培養學生的自主學習能力和升學準備。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '自主管理', '升學規劃'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '高年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '小六安親班': {
      title: '6年級補習+美語安親',
      image: 'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/980b2fd0406282f4454d9952e3576486.jpeg',
      features: ['安親+數學+英文+國語+自然+社會', '接送學校服務', '作業輔導', '美語加強'],
      description: '第一次繳費買3個月安親吃到飽送1個月！安親+數學+英文+國語+自然+社會=平均7375元。小六畢業班的專業輔導，幫助學生做好升國中的各項準備，建立自信心和學習基礎。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['超狂優惠', '安親接送費全免', '升學輔導', '畢業準備'],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '數學 Kahoot',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '國語 Kahoot',
        '17:00-17:50': '英文',
        '18:00-19:30': '高年級創編英檢培訓'
      },
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    },
    '私中菁英安親班': {
      title: '私中菁英安親班',
      images: [
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/3f9c1248637ded25c31aea29a8365f04.jpeg',
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/3dfabdea36f05701344980a2f420f2ca.jpeg',
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/36d469414ec27eef455a7120ff1a9a13.jpeg',
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/58f6f10885ee4f02c801554af460c365.jpeg',
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/26055352ef98b87549fb22c9f603a8eb.jpeg',
        'https://static.readdy.ai/image/808559ab8606c74e6cba6002f4b68f07/f0ed45c656baf90fe52655a4b28b2893.jpeg'
      ],
      features: ['5位專業老師團隊合作', '個人化排課課表', '跨科會診補強策略', '小班精緻教學'],
      description: '私中班會有5個老師進場，每位老師都會分工以團隊合作方式客製化孩子問題。專為有志進入私立中學的學生設計，提供高強度的學術訓練和考試準備。',
      schedule: '12:40-19:30 (含接送時間)',
      highlights: ['師資團隊', '個別輔導', '升學規劃', '學習回饋'],
      teacherTeam: [
        { name: '黃泓瑋', subjects: '英文+自然' },
        { name: 'shu', subjects: '英文+數學' },
        { name: '阿劍', subjects: '國文' },
        { name: '品叡', subjects: '數學+家長溝通' },
        { name: '陳聖玫', subjects: '功課+行政事務' }
      ],
      detailedSchedule: {
        '12:40-13:00': '接送',
        '13:00-13:50': '學校功課處理',
        '14:00-14:50': '寫功課',
        '15:00-15:50': '寫功課',
        '16:00-16:50': '客製化排課',
        '17:00-17:50': '客製化排課',
        '18:00-19:30': '客製化排課'
      },
      teamFeatures: [
        '跨科會診：各科老師定期討論命題趨勢，針對學生弱點規劃補強策略',
        '小班精緻：落實分層教學，尊顯進度與個別差異',
        '升學導向：鎖定各大私中入學考試，提供歷屆考題與模擬試卷',
        '學習回饋：定期提供學習狀況回饋，讓家長與老師保持密切聯繫'
      ],
      pickupSchools: ['僑孝', '四維', '北屯', '文心', '東光', '僑忠', '仁美', '松竹', '文昌', '松強'],
      contact: {
        address: '北屯路388號2樓',
        phone: ['22436255', '0982621889']
      }
    }
  };

  const tabs = Object.keys(courses);

  const handlePrevImage = () => {
    if (activeTab === '私中菁英安親班' && courses[activeTab].images) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? courses[activeTab].images.length - 1 : prev - 1
      );
    }
  };

  const handleNextImage = () => {
    if (activeTab === '私中菁英安親班' && courses[activeTab].images) {
      setCurrentImageIndex((prev) => 
        prev === courses[activeTab].images.length - 1 ? 0 : prev + 1
      );
    }
  };

  return (
    <>
      <section id="elementary" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">國小部課程</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              跳脫體制專為國小學童設計的課程包含傳統安親，國小數學，國小英文，國小自然，國小國文，
              讓孩子在快樂學習中培養多元能力。
            </p>
          </div>

          {/* 標籤導航 */}
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-600 hover:bg-blue-100 hover:text-blue-600'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* 課程內容 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-xl">
            <div className="md:flex">
              <div className="md:w-1/2">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden relative">
                  {activeTab === '私中菁英安親班' && courses[activeTab].images ? (
                    <>
                      <img
                        src={courses[activeTab].images[currentImageIndex]}
                        alt={`${courses[activeTab].title} - ${currentImageIndex + 1}`}
                        className="w-full h-80 md:h-full object-contain object-center"
                      />
                      {/* 輪播控制按鈕 */}
                      <button
                        onClick={handlePrevImage}
                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white w-10 h-10 rounded-full flex items-center justify-center transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-2xl"></i>
                      </button>
                      <button
                        onClick={handleNextImage}
                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white w-10 h-10 rounded-full flex items-center justify-center transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-2xl"></i>
                      </button>
                      {/* 圖片指示器 */}
                      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
                        {courses[activeTab].images.map((_, index) => (
                          <button
                            key={index}
                            onClick={() => setCurrentImageIndex(index)}
                            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                              index === currentImageIndex
                                ? 'bg-white w-8'
                                : 'bg-white/50 hover:bg-white/75'
                            }`}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <img
                      src={courses[activeTab].image}
                      alt={courses[activeTab].title}
                      className="w-full h-80 md:h-full object-contain object-center"
                    />
                  )}
                </div>
              </div>
              <div className="md:w-1/2 p-8">
                <h3 className="text-3xl font-bold text-gray-800 mb-4">
                  {courses[activeTab].title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                  {courses[activeTab].description}
                </p>
                
                <div className="mb-6">
                  <div className="flex items-center text-gray-700 mb-4">
                    <i className="ri-time-line text-blue-500 mr-3 text-xl"></i>
                    <span className="text-lg">{courses[activeTab].schedule}</span>
                  </div>
                </div>

                {/* 小一到小六安親班特殊內容 */}
                {(activeTab === '小一安親班' || activeTab === '小二安親班' || activeTab === '小三安親班' || activeTab === '小四安親班' || activeTab === '小五安親班' || activeTab === '小六安親班') && (
                  <>
                    <div className="mb-6 bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
                      <h4 className="text-xl font-bold text-red-700 mb-2">超狂優惠</h4>
                      <p className="text-red-600 font-medium">第一次繳費買3個月安親吃到飽送1個月！</p>
                      <p className="text-lg font-bold text-red-700 mt-2">
                        {activeTab === '小三安親班' || activeTab === '小四安親班'
                          ? '安親+數學+英文+國語+自然=平均6875元'
                          : activeTab === '小五安親班' || activeTab === '小六安親班'
                          ? '安親+數學+英文+國語+自然+社會=平均7375元'
                          : '安親+數學+英文+國語=平均6375元'
                        }
                      </p>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">詳細課表</h4>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        {Object.entries(courses[activeTab].detailedSchedule).map(([time, subject]) => (
                          <div key={time} className="flex justify-between py-2 border-b border-gray-200 last:border-b-0">
                            <span className="font-medium text-gray-700">{time}</span>
                            <span className="text-gray-600">{subject}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">接送學校</h4>
                      <div className="grid grid-cols-3 gap-2">
                        {courses[activeTab].pickupSchools.map((school, index) => (
                          <div key={index} className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-center text-sm">
                            {school}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">聯絡資訊</h4>
                      <div className="space-y-2">
                        <div className="flex items-center">
                          <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                          <span className="text-gray-700">{courses[activeTab].contact.address}</span>
                        </div>
                        <div className="flex items-center">
                          <i className="ri-phone-line text-green-500 mr-2"></i>
                          <span className="text-gray-700">
                            {courses[activeTab].contact.phone.join(' 或 ')}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {/* 私中菁英安親班特殊內容 */}
                {activeTab === '私中菁英安親班' && (
                  <>
                    <div className="mb-6 bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                      <h4 className="text-xl font-bold text-purple-700 mb-3">師資團隊</h4>
                      <p className="text-purple-600 font-medium mb-3">私中班會有5個老師進場，每位老師都會分工以團隊合作方式客製化孩子問題</p>
                      <div className="space-y-2">
                        {courses[activeTab].teacherTeam.map((teacher, index) => (
                          <div key={index} className="flex items-center justify-between bg-white p-2 rounded">
                            <span className="font-medium text-gray-800">{teacher.name}</span>
                            <span className="text-sm text-gray-600">{teacher.subjects}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">教學節奏</h4>
                      <div className="bg-gray-50 p-4 rounded-lg">
                        {Object.entries(courses[activeTab].detailedSchedule).map(([time, subject]) => (
                          <div key={time} className="flex justify-between py-2 border-b border-gray-200 last:border-b-0">
                            <span className="font-medium text-gray-700">{time}</span>
                            <span className="text-gray-600">{subject}</span>
                          </div>
                        ))}
                        <p className="text-sm text-gray-500 mt-3">每位孩子都會有個人的排課課表</p>
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">團隊特色</h4>
                      <div className="space-y-3">
                        {courses[activeTab].teamFeatures.map((feature, index) => (
                          <div key={index} className="flex items-start">
                            <i className="ri-star-line text-yellow-500 mr-2 text-lg mt-1"></i>
                            <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">接送學校</h4>
                      <div className="grid grid-cols-3 gap-2">
                        {courses[activeTab].pickupSchools.map((school, index) => (
                          <div key={index} className="bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-center text-sm">
                            {school}
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="mb-6">
                      <h4 className="text-xl font-semibold text-gray-800 mb-3">聯絡資訊</h4>
                      <div className="space-y-2">
                        <div className="flex items-center">
                          <i className="ri-map-pin-line text-blue-500 mr-2"></i>
                          <span className="text-gray-700">{courses[activeTab].contact.address}</span>
                        </div>
                        <div className="flex items-center">
                          <i className="ri-phone-line text-green-500 mr-2"></i>
                          <span className="text-gray-700">
                            {courses[activeTab].contact.phone.join(' 或 ')}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                <div className="mb-6">
                  <h4 className="text-xl font-semibold text-gray-800 mb-3">課程特色</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {courses[activeTab].features.map((feature, index) => (
                      <div key={index} className="flex items-center">
                        <i className="ri-check-line text-green-500 mr-2 text-lg"></i>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mb-8">
                  <h4 className="text-xl font-semibold text-gray-800 mb-3">教學亮點</h4>
                  <div className="grid grid-cols-2 gap-3">
                    {courses[activeTab].highlights.map((highlight, index) => (
                      <div key={index} className="flex items-center">
                        <i className="ri-star-line text-yellow-500 mr-2 text-lg"></i>
                        <span className="text-gray-700">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => setIsTrialModalOpen(true)}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap text-lg"
                >
                  預約試聽
                </button>
              </div>
            </div>
          </div>

          <div className="mt-16 bg-white rounded-lg p-8 text-center shadow-lg">
            {/* 小六升國一優惠方案 */}
            <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg p-6 mb-8 shadow-xl">
              <div className="flex items-center justify-center mb-4">
                <i className="ri-graduation-cap-line text-3xl mr-2"></i>
                <h4 className="text-2xl font-bold">🎓 小六升國一特惠方案 🎓</h4>
                <i className="ri-graduation-cap-line text-3xl ml-2"></i>
              </div>
              
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-5 mb-4">
                <h5 className="text-xl font-bold text-yellow-300 mb-3">先修假日班超值優惠</h5>
                <p className="text-2xl font-bold mb-3">數學+英文課程 每月只要 300元！</p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                  <div className="bg-white/10 rounded-lg p-4">
                    <h6 className="font-bold text-yellow-200 mb-2">時段1 - 星期六上午</h6>
                    <div className="space-y-1 text-sm">
                      <p>📚 9:00-10:30 數學</p>
                      <p>📖 10:30-12:00 英文</p>
                    </div>
                  </div>
                  <div className="bg-white/10 rounded-lg p-4">
                    <h6 className="font-bold text-yellow-200 mb-2">時段2 - 星期六下午</h6>
                    <div className="space-y-1 text-sm">
                      <p>📚 13:00-14:30 數學</p>
                      <p>📖 14:30-16:00 英文</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-400 text-purple-800 rounded-lg p-3 font-bold text-lg">
                📞 立即來電報名：04-2243-6255
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-800 mb-4">國小部特色</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-group-line text-blue-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">小班制教學</h4>
                <p className="text-sm text-gray-600">每班最多12人，確保每位學生都能得到充分關注</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-gamepad-line text-green-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">遊戲化學習</h4>
                <p className="text-sm text-gray-600">透過遊戲、歌謠、戲劇等方式讓學習更有趣</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-trophy-line text-yellow-600 text-2xl"></i>
                </div>
                <h4 className="font-semibold mb-2">成果檢定</h4>
                <p className="text-sm text-gray-600">定期參加劍橋、全民英檢等檢定考試</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TrialModal isOpen={isTrialModalOpen} onClose={() => setIsTrialModalOpen(false)} />
    </>
  );
}
